<template>
    <Icon
        class="base-loader"
        name="app:activity_progress"
    />
</template>

<style lang="less">
.base-loader {
    color: var(--color-mma-petrol);
    font-size: 2rem;
    animation: spin 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
